import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';

const Forgot = props => (
  <div className="Forgot">
    <p>Please provide the email address that you used when you signed up for your Future of Tourism Cares account. We will send you an email that will allow you to reset your password.</p>
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="email"
      fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
      icon="at"
      focus
      line
    />
    <div className="login__form--buttons">
      <Link to="/login">
        <button type="button" onClick={props.back} className="Email__input--button btnInverse">{i18n.translate('general.back')}</button>
      </Link>
      <button type="submit" onClick={props.submit} className="Email__input--button">
        {props.loadingAnimRegister ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : 'Submit'}
      </button>
    </div>
  </div>
);

export default Forgot;

Forgot.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

Forgot.defaultProps = {
  defaultVal: '',
};
